<template>
      <!-- 导航 -->
    <div class="top_menu" :style="menuWidth">
      <ul id="top_menu">
        <li v-for="(item,index) in menuList" :key="index" :class="arrClassName[index]"><a :href="item.linkUrl" :target="item.linkNew==1?'_self':'_blank'"><span>{{item.linkName}}</span></a></li>
      </ul>
    </div>

</template>

<script>
import { getTopMenu } from '@/service/api.js'
export default {
  data() {
    return {
      menuList: [],
      menuWidth:'',
      arrClassName: []
    }
  },
  beforeCreate () {
    // 请求数据
    getTopMenu().then((data) => {
      console.log('topMenu',data);
      this.menuList = data.data;
      this.menuWidth = 'width:'+136*this.menuList.length+'px';
      this.menuList.forEach((el,index) => {
        if (index>0) {
          if (location.href.indexOf(el.linkUrl)!=-1) {
            this.arrClassName.push('active')
          }else{
            this.arrClassName.push('')
          }
        }else{
          this.arrClassName.push('')
        }
      })
      if (!this.arrClassName.includes('active')) {
        this.arrClassName[0] = 'active'
      }
    });
  },
}
</script>

<style lang="less" scoped>
.top_menu {
  height: 64px;
  position: relative;
  margin: -35px auto 0;
  z-index: 99;
  li {
    float: left;
    margin-left: -1px;
    a {
      display: block;
      width: 136px;
      height: 64px;
      background-color: #18388b;
      transform: skewX(-20deg);
      color: #FFF;
      line-height: 64px;
      text-align: center;
      &:hover {
        background-color: #2a61b3;
        font-weight: 600;
        span {
          &::after {
            content: '';
            width: 100%;
            height: 2px;
            background-color: #FFF;
            position: absolute;
            left: 0;
            bottom: 20px;
          }
        }
      }
      span {
        display: inline-block;
        transform: skewX(20deg);
        position: relative;
      }
    }
    &.active {
      a{
        background-color: #2a61b3;
        font-weight: 600;
        span {
          &::after {
            content: '';
            width: 100%;
            height: 2px;
            background-color: #FFF;
            position: absolute;
            left: 0;
            bottom: 20px;
          }
        }
      }
    }
  }
}

</style>